import { get, post } from '../index'
import { IBannerListItem } from '@/interface'
import { ICertificationDetail } from '@/interface/certification'
import { BannerType } from '~/typings/index'

const DETAIL_KIND_MAP = {
  0: '8',
  1: '7'
} as Record<string, BannerType>

export const ND_TEACHER_STATUS = {
  yes: '1',
  no: '0'
}

interface ICertificateClassroomQuery {
  certificationId?: number | string
  teachingType: number | string // 0 - 线下，1 - 线上
  regionId?: number | string | null
  kind?: number | string // 0-CGS 1-HSC
}

interface ICertificatePracticalExamQuery {
  certificationId: number | string
  regionId: number | string
}

interface IClassroomEvaluateQuery {
  relationId: number | string
  score: number
  message: string
  // 课程类型 0 面授课程 1 course
  relationType: number
  courseType: string
}

interface ICertificateRegionQuery {
  certificationId: number | string
  teachingType?: string
}

export interface FeedBackQuery {
  relationType: number | string
  relationId: number | string
}

export async function getClassroomByCertificate (data: ICertificateClassroomQuery) {
  return await post('/certification/classroom/getOfCertification', data)
}

export async function getPracticalExamByCertificate (data: ICertificatePracticalExamQuery) {
  return await post('/certification/practicalExam/getOfCertification', data)
}

// 认证详情-课程-地区列表
export async function getClassroomRegionList (data: ICertificateRegionQuery) {
  return await post('/certification/classroom/getRegion', data)
}

// 认证详情-实操考试-地区列表
export async function getPracticalRegionList (data: ICertificateRegionQuery) {
  return await post('/certification/practicalExam/getRegion', data)
}

// 课程打分
export async function classroomEvaluate (data: IClassroomEvaluateQuery) {
  return await post('/certification/evaluate/classroom', { ...data })
}

export async function entroll (relationId: string, emailNotificationStatus: string) {
  return await post('/user/registration/addRegistration', {
    relationId,
    emailNotificationStatus
  })
}

export async function getAllCourse (id: number | string) {
  return await get('/certification/release/course/list', {
    certificationId: id
  })
}

// 获取认证类型筛选list
export async function getCertificationTypes (kind: string | number) {
  return await new Promise((resolve) => {
    get('/certification/release/course/getFilterType', {
      kind
    }).then(res => {
      resolve(res.data)
    }).catch(() => {
      resolve([])
    })
  })
}

// 获取认证详情信息
export async function getCertificateDetail (id: string) {
  const detailRes = await get(`/certification/release/certification/detail?id=${id}`)
  return detailRes?.data
}

export async function getDetail (id: string): Promise<any> {
  return await new Promise((resolve) => {
    get(`/certification/release/certification/detail?id=${id}`).then(res => {
      const certificationDetail: ICertificationDetail = res.data as ICertificationDetail
      Promise.all([
        get('/certification/release/course/list', { certificationId: id }),
        post('/certification/banner/release/query', { typeList: [DETAIL_KIND_MAP[certificationDetail.kind]] })
      ]).then(result => {
        resolve({
          certificationDetail: res.data,
          courseList: result[0].data,
          banner: result[1].data ? (result[1].data as IBannerListItem[])[0] : {}
        })
      }).catch(() => {
        resolve({
          certificationDetail: {},
          courseList: [],
          banner: {}
        })
      })
    }).catch(() => {
      resolve({
        certificationDetail: {},
        courseList: [],
        banner: {}
      })
    })
  })
}

export async function getCertificationList (kind: string) {
  return await get(`/certification/release/certification/list?kind=${kind}`)
}

export async function getCertificationBanner (bannerTypeList: string[]) {
  return await post('/certification/banner/release/query', { typeList: bannerTypeList })
}

// 报名面授课程
export async function enrollClassroom (data: { emailNotificationStatus: string, relationId: number, dietaryRequirements: string, allergies: string }) {
  return await post('/user/registration/enrollClassroom', { ...data })
}

// 取消报名
export async function unenrollClassroom (data: { relationId: number }) {
  return await post('/user/registration/cancelClassroom', { ...data })
}

// 取消报名-实操考试
export async function unenrollPracticalExam (data: { practicalExamId: number }) {
  return await post('/user/practicalExamApprove/cancelPracticalExam', { ...data })
}

// 取消报名-实操考试
export async function getPracticalExamDetail (data: { id: number | string }) {
  return await get('/certification/practicalExam/getById', { ...data })
}

// 获取关联认证
export async function getRelatedCerByCountryLanguage (data: {
  releaseCertificationId: string | number
  languageId: string | number
}) {
  return await get('/certification/release/certification/getByCountryLanguage', data)
}
